import React from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import MarketingLayout from "../../components/marketing/MarketingLayout";
import Seo from "../../components/Seo";
import { SERVICES } from "../../data/site";

export function Services() {
  return (
    <MarketingLayout>
      <Seo title="Services — AllToMAIDIt Solutions" description="Web development, AI & automation, digital marketing, branding and IT solutions." />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20">
        <p className="eyebrow text-alto-red mb-3">Services</p>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold mb-4">Expertise, on demand.</h1>
        <p className="text-neutral-400 max-w-2xl mb-14 text-sm sm:text-base">Engage us for a single service or combine several into a complete custom solution. The problem determines the mix.</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((s) => (
            <Link key={s.slug} to={`/services/${s.slug}`} data-testid={`service-card-${s.slug}`} className="card-hairline rounded-xl p-7 bg-alto-charcoal group">
              <s.icon className="text-alto-red mb-5" size={28} />
              <h2 className="font-display text-xl font-bold group-hover:text-alto-red transition-colors">{s.name}</h2>
              <p className="text-sm text-neutral-400 mt-2">{s.tagline}</p>
              <span className="inline-flex items-center gap-2 text-alto-red text-sm font-semibold mt-5">Learn more <ArrowRight size={15} /></span>
            </Link>
          ))}
        </div>
      </div>
    </MarketingLayout>
  );
}

export function ServiceDetail() {
  const { slug } = useParams();
  const s = SERVICES.find((x) => x.slug === slug);
  if (!s) return <MarketingLayout><div className="max-w-3xl mx-auto px-6 py-28 text-center"><h1 className="font-display text-3xl font-bold">Service not found</h1><Link to="/services" className="text-alto-red mt-4 inline-block">Back to Services</Link></div></MarketingLayout>;
  return (
    <MarketingLayout>
      <Seo title={`${s.name} — AllToMAIDIt Solutions`} description={s.desc} />
      <div className="marketing-grid-bg border-b border-white/10">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-12 py-20">
          <Link to="/services" className="text-sm text-neutral-400 hover:text-white">← All Services</Link>
          <s.icon className="text-alto-red my-6" size={40} />
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold">{s.name}</h1>
          <p className="text-neutral-300 mt-5 max-w-2xl text-sm sm:text-lg leading-relaxed">{s.desc}</p>
        </div>
      </div>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-12 py-16">
        <h2 className="font-display text-2xl font-bold mb-8">What's included</h2>
        <div className="grid sm:grid-cols-2 gap-4">
          {s.points.map((p) => (
            <div key={p} className="flex items-start gap-3 card-hairline rounded-lg p-5 bg-alto-charcoal"><Check className="text-alto-red shrink-0 mt-0.5" size={18} /><span className="text-sm text-neutral-200">{p}</span></div>
          ))}
        </div>
        <div className="mt-12 flex flex-col sm:flex-row gap-4">
          <Link to="/contact" className="btn-red font-bold px-7 py-4 rounded-md inline-flex items-center justify-center gap-2 text-sm">LET'S BUILD YOUR SOLUTION <ArrowRight size={18} /></Link>
          <Link to="/solutions" className="font-bold px-7 py-4 rounded-md border border-white/20 hover:border-alto-red hover:text-alto-red transition-colors text-sm text-center">VIEW SOLUTIONS</Link>
        </div>
      </div>
    </MarketingLayout>
  );
}
